export default function percentageFormat(val: number | string): string {
  if (!val || isNaN(Number(val))) {
    return "";
  }

  return new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    roundingMode: "trunc"
  }).format(Number(val));
}
